import { cache } from 'tm3-core/cache';

export function WhatIsAPassKey() {
  return (
    <details className="my-1 cursor-pointer text-gray-500">
      <summary>What is a Pass Key?</summary>
      <div className="mt-2 rounded-md border border-gray-200 p-4">
        <p>
          Passkeys give you a simple and secure way to sign in to apps and websites without
          passwords by relying on things like Face ID, Touch ID and other Biometrics to identify you
          when you sign in.
        </p>
        <p className="mt-2">
          Passkeys are a new technology, and some devices may not support them. You can safely try
          to set up a Passkey, and if it doesn't succeed, then you can use an Authenticator App or
          SMS Authentication instead.
        </p>
        <p className="mt-2">
          For more information see our knowledge base article{' '}
          <a
            target="_blank"
            href={
              process.env.isClick
                ? 'https://help.click-hub.com/en/articles/6967998-what-is-a-passkey'
                : `${cache.helpUrl}/en/articles/4581695-what-is-a-passkey`
            }
          >
            What is a Pass Key?
          </a>
        </p>
      </div>
    </details>
  );
}
